(function () {
    /**
     * Initializes the Hello Retail fallback recommendations
     * @param {HTMLElement} container - The fallback container
     */
    const initHelloRetailFallback = async (container) => {
        // Prevent double initialization
        if (container.dataset.hrInit === 'true') return;
        container.dataset.hrInit = 'true';

        // Check if original content is visible (i.e., native recommendations logic didn't find any products)
        // If native recommendations were found, the liquid logic might still render this container but hide it.
        // Or if using product-recommendations, it replaces content.

        // We assume if this container is present in the DOM, we should try to fill it.
        // It is hidden by default: style="display: none;"

        const productId = container.dataset.productId;
        const sectionId = 'complementary-products-recommendations';

        if (!productId) return;

        try {
            // Ensure service is available
            if (!window.HelloRetailService) {
                console.warn('HelloRetailService not available yet, retrying...');
                setTimeout(() => {
                    // Reset init flag and retry
                    container.dataset.hrInit = 'false';
                    initHelloRetailFallback(container);
                }, 500);
                return;
            }

            // 1. Fetch recommendations from Hello Retail
            const result = await window.HelloRetailService.fetchRecommendations({
                awsKey: 'product-page-complementary',
                productIds: [productId],
                count: 10,
                filters: { inStock: "true" }
            });

            const products = result?.products;
            const trackingKey = result?.trackingKey || null;

            if (!products || products.length === 0) {
                console.log('Complementary Fallback: No products from Hello Retail');
                return;
            }

            // 2. Construct search query for Section Rendering API
            const query = products
                .map(p => `id:${p.productNumber || p.id}`)
                .join(' OR ');

            // 3. Fetch HTML
            const searchUrl = window.routes?.search_url || '/search';
            const url = `${searchUrl}?section_id=${sectionId}&type=product&q=${encodeURIComponent(query)}`;

            const response = await fetch(url);
            if (!response.ok) throw new Error('Network response was not ok');

            const text = await response.text();

            // 4. Inject HTML (show container first so carousel-slider's IntersectionObserver can fire)
            const contentContainer = container.querySelector('.complementary-products-content');
            if (contentContainer) {
                container.style.display = 'block';
                contentContainer.innerHTML = text;

                // 5. Attach Hello Retail click tracking to all product links and buttons
                if (trackingKey) {
                    contentContainer.querySelectorAll('a, button[name="add"], .js-quick-add').forEach(el => {
                        el.addEventListener('click', () => {
                            const hrq = window.hrq || [];
                            hrq.push(['trackClick', trackingKey]);
                        });
                    });
                }
            }

        } catch (error) {
            console.error('Complementary Fallback Error:', error);
        }
    };

    // Observer to detect when the fallback container is injected into the DOM
    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (node.nodeType === 1) { // Element node
                    // Check if the node itself is the fallback container
                    if (node.classList && node.classList.contains('hello-retail-fallback')) {
                        initHelloRetailFallback(node);
                    }
                    // Check if the fallback container is inside the added node
                    const fallback = node.querySelector('.hello-retail-fallback');
                    if (fallback) {
                        initHelloRetailFallback(fallback);
                    }
                }
            }
        }
    });

    // Start observing the document body
    if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
    } else {
        document.addEventListener('DOMContentLoaded', () => {
            observer.observe(document.body, { childList: true, subtree: true });
        });
    }

    // Check if element already exists (in case script runs after injection)
    document.addEventListener('DOMContentLoaded', () => {
        const fallbacks = document.querySelectorAll('.hello-retail-fallback');
        fallbacks.forEach(initHelloRetailFallback);
    });

})();
